module.exports = __webpack_public_path__ + "img/electronic_pending_zone_selected.b51e1a08.svg";